module.exports = __webpack_public_path__ + "static/img/COC2021-10.4c9cc84.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-10.jpg
// module id = e2KC
// module chunks = 0